import DocumentStatusRing from "../../../hospitalPersona/caseDetails/DocumentStatusRing";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
const MappedDocInfo = ({ cas }) => {
  const calculatePrcentage = (uploaded, total) => {
    let percent = 0;
    if (total !== 0) {
      percent = (uploaded / total) * 100;
    }
    return percent;
  };
  return (
    <div className="flex justify-center items-center h-fit">
      <div
        style={{
          position: "relative",
          width: 60,
          height: 60,
        }}
      >
        <DocumentStatusRing
          size={60}
          strokeWidth={4}
          reviewPending={
            cas?.submasterstagestatuses[0]?.commandCenterStage
              ?.toLowerCase()
              .includes("admission")
              ? calculatePrcentage(
                  cas?.totalAdmissionDocuments -
                    cas?.admissionDocumentsPending -
                    cas?.admissionDocumentsRejected -
                    cas?.admissionDocumentsApproved,
                  cas?.totalAdmissionDocuments - cas?.admissionDocumentsPending
                )
              : cas?.submasterstagestatuses[0]?.commandCenterStage
                  ?.toLowerCase()
                  .includes("enhancement")
              ? calculatePrcentage(
                  cas?.totalLatestEnhancementDocuments -
                    cas?.latestEnhancementPending -
                    cas?.latestEnhancementRejected -
                    cas?.latestEnhancementApproved,
                  cas?.totalLatestEnhancementDocuments -
                    cas?.latestEnhancementPending
                )
              : cas?.submasterstagestatuses[0]?.commandCenterStage
                  ?.toLowerCase()
                  .includes("discharge") ||
                cas?.submasterstagestatuses[0]?.commandCenterStage
                  ?.toLowerCase()
                  .includes("claim")
              ? calculatePrcentage(
                  cas?.totalOnDischargeDocuments -
                    cas?.onDischargePending -
                    cas?.onDischargeRejected -
                    cas?.onDischargeApproved,
                  cas?.totalOnDischargeDocuments - cas?.onDischargePending
                )
              : 0
          }
          approved={
            cas?.submasterstagestatuses[0]?.commandCenterStage
              ?.toLowerCase()
              .includes("admission")
              ? calculatePrcentage(
                  cas?.admissionDocumentsApproved,
                  cas?.totalAdmissionDocuments - cas?.admissionDocumentsPending
                )
              : cas?.submasterstagestatuses[0]?.commandCenterStage
                  ?.toLowerCase()
                  .includes("enhancement")
              ? calculatePrcentage(
                  cas?.latestEnhancementApproved,
                  cas?.totalLatestEnhancementDocuments -
                    cas?.latestEnhancementPending
                )
              : cas?.submasterstagestatuses[0]?.commandCenterStage
                  ?.toLowerCase()
                  .includes("discharge") ||
                cas?.submasterstagestatuses[0]?.commandCenterStage
                  ?.toLowerCase()
                  .includes("claim")
              ? calculatePrcentage(
                  cas?.onDischargeApproved,
                  cas?.totalOnDischargeDocuments - cas?.onDischargePending
                )
              : 0
          }
          rejected={
            cas?.submasterstagestatuses[0]?.commandCenterStage
              ?.toLowerCase()
              .includes("admission")
              ? calculatePrcentage(
                  cas?.admissionDocumentsRejected,
                  cas?.totalAdmissionDocuments - cas?.admissionDocumentsPending
                )
              : cas?.submasterstagestatuses[0]?.commandCenterStage
                  ?.toLowerCase()
                  .includes("enhancement")
              ? calculatePrcentage(
                  cas?.latestEnhancementRejected,
                  cas?.totalLatestEnhancementDocuments -
                    cas?.latestEnhancementPending
                )
              : cas?.submasterstagestatuses[0]?.commandCenterStage
                  ?.toLowerCase()
                  .includes("discharge") ||
                cas?.submasterstagestatuses[0]?.commandCenterStage
                  ?.toLowerCase()
                  .includes("claim")
              ? calculatePrcentage(
                  cas?.onDischargeRejected,
                  cas?.totalOnDischargeDocuments - cas?.onDischargePending
                )
              : 0
          }
        />

        <div className="absolute -top-6  flex gap-1 text-xs text-[#B0D6D3] z-[20]">
          {cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("admission") ? (
            <>
              <div className="h-[20px] w-[20px] flex items-center justify-center bg-[#FFC8C8] text-[#FF1818] rounded-full p-1">
                {cas?.admissionDocumentsRejected}
              </div>

              <div className="h-[20px] w-[20px] flex items-center justify-center bg-[#CDFAF4] text-[#017C57] rounded-full p-1">
                {cas?.admissionDocumentsApproved}
              </div>

              <div className=" h-[20px] w-[20px] flex items-center justify-center bg-[#969696] text-[white] rounded-full p-1 ">
                {cas?.totalAdmissionDocuments -
                  cas?.admissionDocumentsPending -
                  cas?.admissionDocumentsRejected -
                  cas?.admissionDocumentsApproved}
              </div>
            </>
          ) : cas?.submasterstagestatuses[0]?.commandCenterStage
              ?.toLowerCase()
              .includes("enhancement") ? (
            <>
              <div className="h-[20px] w-[20px] flex items-center justify-center bg-[#FFC8C8] text-[#FF1818] rounded-full p-1">
                {cas?.latestEnhancementRejected}
              </div>

              <div className="h-[20px] w-[20px] flex items-center justify-center bg-[#CDFAF4] text-[#017C57] rounded-full p-1">
                {cas?.latestEnhancementApproved}
              </div>

              <div className=" h-[20px] w-[20px] flex items-center justify-center bg-[#969696] text-[white] rounded-full p-1 ">
                {cas?.totalLatestEnhancementDocuments -
                  cas?.latestEnhancementPending -
                  cas?.latestEnhancementRejected -
                  cas?.latestEnhancementApproved}
              </div>
            </>
          ) : cas?.submasterstagestatuses[0]?.commandCenterStage
              ?.toLowerCase()
              .includes("discharge") ||
            cas?.submasterstagestatuses[0]?.commandCenterStage
              ?.toLowerCase()
              .includes("claim") ? (
            <>
              <div className="h-[20px] w-[20px] flex items-center justify-center bg-[#FFC8C8] text-[#FF1818] rounded-full p-1">
                {cas?.onDischargeRejected}
              </div>

              <div className="h-[20px] w-[20px] flex items-center justify-center bg-[#CDFAF4] text-[#017C57] rounded-full p-1">
                {cas?.onDischargeApproved}
              </div>

              <div className=" h-[20px] w-[20px] flex items-center justify-center bg-[#969696] text-[white] rounded-full p-1 ">
                {cas?.totalOnDischargeDocuments -
                  cas?.onDischargePending -
                  cas?.onDischargeRejected -
                  cas?.onDischargeApproved}
              </div>
            </>
          ) : (
            0
          )}
        </div>
        {/* Centered Text */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            height: "75%",
            width: "75%",
            transform: "translate(-50%, -50%)",
            fontSize: "24px",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          <CircularProgressbarWithChildren
            value={
              cas?.submasterstagestatuses[0]?.commandCenterStage
                ?.toLowerCase()
                .includes("admission")
                ? calculatePrcentage(
                    cas?.totalAdmissionDocuments -
                      cas?.admissionDocumentsPending,
                    cas?.totalAdmissionDocuments
                  )
                : cas?.submasterstagestatuses[0]?.commandCenterStage
                    ?.toLowerCase()
                    .includes("enhancement")
                ? calculatePrcentage(
                    cas?.totalLatestEnhancementDocuments -
                      cas?.latestEnhancementPending,
                    cas?.totalLatestEnhancementDocuments
                  )
                : cas?.submasterstagestatuses[0]?.commandCenterStage
                    ?.toLowerCase()
                    .includes("discharge") ||
                  cas?.submasterstagestatuses[0]?.commandCenterStage
                    ?.toLowerCase()
                    .includes("claim")
                ? calculatePrcentage(
                    cas?.totalOnDischargeDocuments - cas?.onDischargePending,
                    cas?.totalOnDischargeDocument
                  )
                : 0
            } // value in percentage
            strokeWidth={14}
            styles={{
              path: {
                stroke: "#969696",
                strokeLinecap: "round",
                transformOrigin: "center center",
              },
              trail: {
                stroke: "#B0D6D3",
                transformOrigin: "center center",
              },
            }}
          >
            {" "}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                fontSize: "10px",
                color: "#017C57",
                fontFamily: "inter, sans-serif",
                fontWeight: 500,
                // paddingBottom: "14px",
              }}
            >
              {cas?.submasterstagestatuses[0]?.commandCenterStage
                ?.toLowerCase()
                .includes("admission") ? (
                <div className="text-[#B0D6D3]">
                  <span className="text-[#969696]">
                    {cas?.totalAdmissionDocuments -
                      cas?.admissionDocumentsPending}
                  </span>
                  {"/"}
                  <span className="text-[#000]">
                    {cas?.totalAdmissionDocuments}
                  </span>
                </div>
              ) : cas?.submasterstagestatuses[0]?.commandCenterStage
                  ?.toLowerCase()
                  .includes("enhancement") ? (
                <div>
                  {" "}
                  <span className="text-[#969696]">
                    {cas?.totalLatestEnhancementDocuments -
                      cas?.latestEnhancementPending}
                  </span>
                  {"/"}
                  <span className="text-[#000]">
                    {cas?.totalLatestEnhancementDocuments}
                  </span>
                </div>
              ) : cas?.submasterstagestatuses[0]?.commandCenterStage
                  ?.toLowerCase()
                  .includes("discharge") ||
                cas?.submasterstagestatuses[0]?.commandCenterStage
                  ?.toLowerCase()
                  .includes("claim") ? (
                <div>
                  <span className="text-[#969696]">
                    {cas?.totalOnDischargeDocuments - cas?.onDischargePending}
                  </span>
                  {"/"}
                  <span className="text-[#000]">
                    {cas?.totalOnDischargeDocuments}
                  </span>
                </div>
              ) : (
                `0/0`
              )}
            </div>
          </CircularProgressbarWithChildren>
        </div>
      </div>
    </div>
  );
};

export default MappedDocInfo;
